<!--
     <LinkInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props: 
     - (all TextField accepted props)
-->

<template>
  <TextInput
    :props="input_props"
    :required_rule="required_rule"
    @update="update"
  />
</template>
<script>
  import TextInput from '@/components/inputs/TextInput'
  export default {
    name: 'LinkInput',

    components: {
      TextInput,
    },

    props: ['props', 'required_rule'],

    data: () => ({
      valid: true,
      show: true,
    }),
    mounted(){
    },

    computed: {
      value() {
        return this.props.value || null
      },
      input_props() {
        return {...this.props,'rules': (this.props.rules || []).concat([this.isURL])};
      }
    },

    methods: {
      validate() {
        return this.valid
      },
      
      isURL(str) {
        if (!str) {
          return true;
        }
        let url;

        const invalid_link_text = this.$vuetify.lang.translator('inputs.link_invalid');
        try {
          url = new URL(str);
        } catch (_) {
          return invalid_link_text;
        }

        return url.protocol === "http:" || url.protocol === "https:" || invalid_link_text;
      },

      update(value) {
        this.$emit('update',value);
      },
    },
  }
</script>
<style lang="scss">
  @import '@/sass/modalform.scss';
</style>
